import { FilterGroup } from '@customer/filters/types';
import useFilters from '@customer/filters/useFilters';
import { TechLibraryQueryParams, useGetTechDocsQuery } from '@customer/store/apis/documentsApi';
import { useAppSelector } from '@customer/store/hooks';
import { useMemo } from 'react';

// The purpose of this hook is to make it easier to keep the query identical between parent and child components for the sake of caching.
export const useTechLibrary = () => {
  const sidePanelModelId = useAppSelector(state => state.global.sidePanelModelId);

  const filters = useFilters<TechLibraryQueryParams>(FilterGroup.TechLibrary);

  const { data, error } = useGetTechDocsQuery(filters, {
    refetchOnMountOrArgChange: true,
    refetchOnReconnect: true,
    skip: sidePanelModelId === undefined,
  });

  const matchedItem = useMemo(() => {
    if (data && sidePanelModelId) {
      const lookupId = parseInt(sidePanelModelId);
      return data.items.find(i => i.id === lookupId);
    }

    return undefined;
  }, [sidePanelModelId, data]);

  return {
    doc: matchedItem,
    error,
  };
};

export default useTechLibrary;
